/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const AutoDeletePreviewResponseDTOMatchModeEnum = {
    All: 'ALL',
    Any: 'ANY'
};
/**
 * Check if a given object implements the AutoDeletePreviewResponseDTO interface.
 */
export function instanceOfAutoDeletePreviewResponseDTO(value) {
    return true;
}
export function AutoDeletePreviewResponseDTOFromJSON(json) {
    return AutoDeletePreviewResponseDTOFromJSONTyped(json, false);
}
export function AutoDeletePreviewResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matchingCount': json['matchingCount'] == null ? undefined : json['matchingCount'],
        'inventoryCount': json['inventoryCount'] == null ? undefined : json['inventoryCount'],
        'sharePercent': json['sharePercent'] == null ? undefined : json['sharePercent'],
        'hasCriteria': json['hasCriteria'] == null ? undefined : json['hasCriteria'],
        'maxProductsPerRunLimit': json['maxProductsPerRunLimit'] == null ? undefined : json['maxProductsPerRunLimit'],
        'breakerSharePercent': json['breakerSharePercent'] == null ? undefined : json['breakerSharePercent'],
        'matchMode': json['matchMode'] == null ? undefined : json['matchMode'],
    };
}
export function AutoDeletePreviewResponseDTOToJSON(json) {
    return AutoDeletePreviewResponseDTOToJSONTyped(json, false);
}
export function AutoDeletePreviewResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matchingCount': value['matchingCount'],
        'inventoryCount': value['inventoryCount'],
        'sharePercent': value['sharePercent'],
        'hasCriteria': value['hasCriteria'],
        'maxProductsPerRunLimit': value['maxProductsPerRunLimit'],
        'breakerSharePercent': value['breakerSharePercent'],
        'matchMode': value['matchMode'],
    };
}
